export const RATING_TIMER_DURATION = 3 * 60 * 1000;

export const ADDITIONAL_CLASSES = {
    CONTAINER: "flex justify-center items-center min-h-fit w-full px-4",
    RATING_CONTAINER: "flex flex-col justify-center rounded-3xl border-solid shadow-md bg-stone-50 border-1 border-[color:var(--Color-Red-red-500,#AD1700)] w-full max-w-3xl mx-auto",
    SHARE_BUTTON_CONTAINER: "px-1 py-1 w-11/12 flex flex-col justify-end rounded-3xl items-end mx-auto",
    PERSONA_CONTAINER: "px-1 py-1 w-11/12 flex flex-col justify-start rounded-3xl items-start mx-auto overflow-visible",
};
